import useSWR from 'swr'
import type { Depositor } from 'views/ProjectsV2/Shortlist/types'

const extractList = (body: any): Depositor[] => {
  if (Array.isArray(body)) return body
  if (Array.isArray(body?.data)) return body.data
  if (Array.isArray(body?.depositors)) return body.depositors
  if (Array.isArray(body?.data?.depositors)) return body.data.depositors
  return []
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include' }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text()
      throw new Error(`GET failed: ${res.status} ${text}`)
    }
    const body = await res.json()
    return extractList(body)
  })

type Options = {
  /** When true, suppress focus revalidation (use while admin has unsaved edits). */
  paused?: boolean
}

const useDealDepositors = (dealId: string | null, options: Options = {}) => {
  const key = dealId
    ? `${process.env.REACT_APP_BACKEND_URL}/api/v2/admin/deals/${dealId}/depositors`
    : null

  const { data, error, isLoading, mutate } = useSWR<Depositor[]>(key, fetcher, {
    refreshInterval: options.paused ? 0 : 30000,
    revalidateOnFocus: !options.paused,
  })

  return {
    depositors: Array.isArray(data) ? data : [],
    isLoading,
    isError: error,
    mutate,
  }
}

export default useDealDepositors
